<template>
	<div id="resetpassword" class="login-page">

		<!-- Background geometry -->
		<div class="login-bg-lines" aria-hidden="true"></div>
		<div class="login-bg-circle login-bg-circle--1" aria-hidden="true"></div>
		<div class="login-bg-circle login-bg-circle--2" aria-hidden="true"></div>

		<!-- ── Split card ── -->
		<div class="login-card">

			<div class="login-card-body">

			<!-- LEFT: form panel -->
			<div class="login-panel-form">
				<!-- Black top bar, logo -->
				<div class="login-topbar">
					<img class="login-topbar-logo" src="../images/bungalow7-logo-white-bg.png" alt="Logo">
				</div>
				<div class="login-form-inner">
					<div class="login-eyebrow">{{ SiteName }}</div>
					<h1 class="login-title">{{ pageTitle }}</h1>
					<p class="login-subtitle">Enter your new password to {{ isActivate ? 'activate your' : 'sign in to your' }} administrative account.</p>

					<el-form ref="setpasswordForm" label-position="top" :model="user" :rules="rules" class="login-form">

						<el-form-item prop="NewPassword">
							<template #label><span class="login-field-label">New Password</span></template>
							<el-input placeholder="********" type="password" v-model="user.NewPassword" size="large" show-password>
								<template #prepend><i class="fa-light fa-lock"></i></template>
							</el-input>
						</el-form-item>

						<el-form-item prop="CnfmPassword">
							<template #label><span class="login-field-label">Confirm Password</span></template>
							<el-input placeholder="********" type="password" v-model="user.CnfmPassword" size="large" show-password @keyup.enter="submit">
								<template #prepend><i class="fa-light fa-lock"></i></template>
							</el-input>
						</el-form-item>
						<el-button type="primary" class="login-submit-btn" :loading="currentStatus === 1" @click="submit">
							<i v-if="currentStatus !== 1" class="fa-light fa-check"></i>&ensp;{{ submitLabel }}
						</el-button>
					</el-form>
				</div>
			</div><!-- /login-panel-form -->

			<!-- RIGHT: info panel -->
			<div class="login-panel-info">
				<div class="login-panel-accent" aria-hidden="true"></div>
				<div class="login-info-inner">
					<h2>Instructions</h2>
					<div class="login-welcome-text" v-html="passwordMessage"></div>
				</div>
			</div><!-- /login-panel-info -->

			</div><!-- /login-card-body -->

		</div><!-- /login-card -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
	name: 'ResetPassword',
	data() {
		var validateNewPassword = (rule, value, callback) => {
			if (!value) {
			    callback(new Error('New Password is Required'));
			} else {
				if (this.config.Params.passwordMinLength && value.length < this.config.Params.passwordMinLength) {
					callback(new Error('Minimum Password length is ' +this.config.Params.passwordMinLength));
				} else if (this.config.Params.passwordRequireNumber == 'y' && !value.match(/\d+/g)) {
					callback(new Error('Must contain at least one number'));
				} else if (this.config.Params.passwordRequireUpper == 'y' && !value.match(/[A-Z]+/g)) {
					callback(new Error('Must contain at least one Upper Case Letter'));
				} else if (this.user.CnfmPassword !== '') {
			        this.$refs.setpasswordForm.validateField('CnfmPassword');
				}
				callback();
			}
		};
		var validateCnfmPassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('Confirm Password is Required'));
			} else if (value !== this.user.NewPassword) {
				callback(new Error('New and Confirm Passwords must match'));
			} else {
				callback();
			}
		};
		return {
			user: {NewPassword: '', CnfmPassword: ''},
			currentStatus: 0,
			rules: {
				NewPassword: [
					{ validator: validateNewPassword, trigger: 'blur' }
				],
				CnfmPassword: [
					{ validator: validateCnfmPassword, trigger: 'blur' }
				]
			}
		}
	},
	props:["config"],
	computed: {
		SiteName() {
			return this.config.Params.SiteName
		},
		passwordMessage () {
			if (this.isActivate) {
				var msg = 'To Activate your account, please set your Password.  You will then be able to login.<br><br>';
			} else {
				var msg = '';
			}
			msg += 'Passwords must be at least ' + this.config.Params.passwordMinLength + ' digits long. ';
			if (this.config.Params.passwordRequireUpper == 'y') {
				msg += 'Passwords must contain at least one UPPER case letter. ';
			}
			if (this.config.Params.passwordRequireNumber == 'y') {
				msg += 'Passwords must contain at least one Number. ';
			}
			return msg;
		},
		isReset () {
			return (this.$route.fullPath.indexOf('reset') !== -1 ? true : false);
		},
		isActivate () {
			return (this.$route.fullPath.indexOf('activate') !== -1 ? true : false);
		},
		pageTitle () {
			if (this.isReset) {
				return 'Reset Password';
			} else {
				return 'Account Activation';
			}
		},
		submitLabel () {
			if (this.isReset) {
				return 'Update Password';
			} else {
				return 'Set Password';
			}
		}
	},
	methods: {
		initialize() {
			this.user.code = this.$route.query.code;
		},
	    submit() {
	        this.$refs['setpasswordForm'].validate((valid) => {
	            if (valid) {
					if (this.currentStatus == STATUS_SAVING) {
						return true;
					}
					this.errors = {};
					this.currentStatus = STATUS_SAVING;
					axios.post('/Login/ResetPassword', {
						ResetUser: this.user, reset: (this.isReset ? 'y' : 'n')
					}).then(response => {
						this.currentStatus = STATUS_INITIAL;
						if (response.data.result == 'success') {
							this.$notify({
								title: 'Success',
								message: "Password has been set, Please login.",
								type: 'success',
								duration: 1500,
								showClose: false
							});
			                let self = this;
			                setTimeout(() => { self.$router.replace((localStorage.subdomain ? '/' + localStorage.subdomain : '') + '/login'); }, 1500);
		                } else {
							this.displayPopup (response.data.message);
							if (response.data.errors) {
								this.errors = response.data.errors;
							}
		                }
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
					});
				}
			});
	    },
        displayPopup (message) {
			this.$alert(message, this.pageTitle + ' Error', {
				confirmButtonText: 'OK',
			});
        }
	},
	mounted() {
		this.initialize();
	}
}
</script>
<style>

/* ── Page shell ──────────────────────────────────────────── */
#app.resetpassword {
	margin-top: 0;
	height: 100vh;
	overflow: auto;
	background: #0D1B2A;
}
#app.resetpassword .page-wrapper {
	margin: 0;
	padding: 0;
}
#app.resetpassword .container-fluid { padding: 0; }

/* ── Full-page background ────────────────────────────────── */
.login-page {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #F8FAFC;
	padding: 20px;
	position: relative;
	overflow: hidden;
}

/* Diagonal texture */
.login-bg-lines {
	position: absolute;
	inset: 0;
	background-image:
		repeating-linear-gradient(
			-55deg,
			transparent, transparent 48px,
			rgba(63, 156, 168, 0.06) 48px, rgba(63, 156, 168, 0.06) 49px
		);
	pointer-events: none;
}

/* Glowing orbs */
.login-bg-circle {
	position: absolute;
	border-radius: 50%;
	pointer-events: none;
	filter: blur(80px);
}
.login-bg-circle--1 {
	width: 500px; height: 500px;
	left: -120px; bottom: -120px;
	background: rgba(63, 156, 168, 0.20);
}
.login-bg-circle--2 {
	width: 360px; height: 360px;
	right: -80px; top: -80px;
	background: rgba(148, 163, 184, 0.12);
}

/* ── Split card ──────────────────────────────────────────── */
.login-card {
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 900px;
	min-height: 520px;
	border-radius: 18px;
	overflow: hidden;
	box-shadow:
		0 0 0 1px rgba(255,255,255,0.06),
		0 32px 80px rgba(0,0,0,0.35);
	animation: login-rise 0.55s cubic-bezier(0.22,1,0.36,1) both;
}

/* ── Top bar: black strip carrying the logo ──────────────── */
/* The logo artwork is designed for a dark background, so it gets its
   own bar rather than sitting on the white form panel. */
.login-topbar {
	background: #ffffff;
	width: 100%;
	text-align: center;
	flex-shrink: 0;
}
.login-topbar-logo {
	max-width: 300px;
	max-height: 100px;
	object-fit: contain;
}

.login-card-body {
	display: flex;
	flex: 1;
	min-height: 0;
}
@keyframes login-rise {
	from { opacity: 0; transform: translateY(28px); }
	to   { opacity: 1; transform: translateY(0); }
}

/* ── LEFT: form panel ────────────────────────────────────── */
.login-panel-form {
	flex: 1;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0;
}
.login-form-inner {
	width: 100%;
	max-width: 420px;
	padding: 30px 0;
}
.login-eyebrow {
	font-size: 10.5px;
	font-weight: 700;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	color: var(--el-color-primary, #3F9CA8);
	margin-bottom: 6px;
}
.login-title {
	font-family: 'Chakra Petch', sans-serif;
	font-size: 28px;
	font-weight: 700;
	color: #0D1B2A;
	margin-bottom: 8px;
	letter-spacing: -0.02em;
	line-height: 1.2;
}
.login-subtitle {
	font-size: 13px;
	color: #64748B;
	margin-bottom: 24px;
	line-height: 1.6;
}

/* Form fields */
.login-form .el-form-item { margin-bottom: 18px; }
.login-form .el-input--large .el-input__wrapper { padding: 0; }
.login-form .el-form-item__label { padding-bottom: 5px; line-height: 1.4; }
.login-form  .el-icon.el-input__password, .login-form .el-input__suffix {
	margin-right: 3px;
}
.login-field-label {
	font-size: 12px;
	font-weight: 600;
	color: #475569;
}
.login-field-label-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
.login-forgot {
	font-size: 12px;
	color: var(--el-color-primary, #3F9CA8);
	text-decoration: none;
	font-weight: 400;
	float:right;
}
.login-forgot:hover { text-decoration: underline; }

/* Sign In button */
.login-submit-btn {
	width: 100%;
	height: 44px !important;
	font-size: 14px !important;
	font-weight: 600 !important;
	border-radius: 10px !important;
	margin-top: 6px;
	letter-spacing: 0.02em;
}

/* ── RIGHT: info panel ───────────────────────────────────── */
.login-panel-info {
	width: 40%;
	background: linear-gradient(150deg, #0D1B2A 0%, #123F4A 50%, #1B5F6C 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 44px 36px;
	position: relative;
	overflow: hidden;
}
.login-panel-accent {
	position: absolute;
	top: -40%;
	right: -30%;
	width: 280px;
	height: 280px;
	border-radius: 50%;
	background: rgba(63, 156, 168, 0.16);
}
.login-panel-accent::after {
	content: '';
	position: absolute;
	bottom: -80px;
	left: -60px;
	width: 200px;
	height: 200px;
	border-radius: 50%;
	background: rgba(63, 156, 168, 0.10);
}
.login-info-inner {
	position: relative;
	z-index: 1;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
}
.login-info-logo-wrap:empty { display: none; }
.login-info-logo {
	max-width: 160px;
	max-height: 70px;
	object-fit: contain;
}
.login-info-inner h2 {
	font-family: 'Chakra Petch', sans-serif;
	font-size: 22px;
	font-weight: 600;
	color: #ffffff;
	margin: 0;
	letter-spacing: -0.01em;
}
.login-welcome-text {
	font-size: 13px;
	color: rgba(255,255,255,0.62);
	line-height: 1.7;
}
.login-welcome-text p { margin: 0; color: rgba(255,255,255,0.62); }
.login-contact-btn {
	margin-top: 4px;
	border-radius: 10px;
	background: rgba(255,255,255,0.10) !important;
	border: 1px solid rgba(255,255,255,0.22) !important;
	color: rgba(255,255,255,0.9) !important;
	font-size: 13px;
	font-weight: 600;
	height: 40px;
	padding: 0 20px;
	transition: background 0.2s;
}
.login-contact-btn:hover { background: rgba(255,255,255,0.18) !important; }

/* ── Element Plus overrides ──────────────────────────────── */
#app.resetpassword .el-input__inner  { padding: 0 10px; }
#app.resetpassword .el-input__prefix { color: #94A3B8; }
#app.resetpassword .el-form-item__label { width: 100%; }

/* ── Responsive ──────────────────────────────────────────── */
@media (max-width: 680px) {
	.login-panel-info { display: none; }
	.login-panel-form { padding: 36px 28px; }
	.login-card { min-height: auto; }
}
@media (max-width: 400px) {
	.login-panel-form { padding: 28px 20px; }
	.login-form-inner { max-width: 100%; }
}

</style>
